import React, { useEffect, useMemo, useRef, useState } from "react";
import './styles.css';
import axios from "axios";

export interface DeicingLogFilterData {
    company?: string | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    year?: number;
}

export interface DeicingFormItem {
    type1FluidConsumption: number | null;
    fluidRatio: string | null;
    waterConsumption: number | null;
    note?: string | null;
}

export interface DeicingLogFilterDialogWindowProps {
    onCloseDialog?: () => void
    onConfirmDialog?: (data?: DeicingLogFilterData) => void
}

const DeicingLogFilterDialogWindow: React.FC<DeicingLogFilterDialogWindowProps> = ({ onCloseDialog, onConfirmDialog }) => {

    const [formData, setFormData] = useState<DeicingLogFilterData>();
    const [year, setYear] = useState<number>(
        new Date().getFullYear()
    );

    useEffect(() => {
        updateField("year", new Date().getFullYear());
    }, []);

    const updateField = <K extends keyof DeicingLogFilterData>(
        field: K,
        value: DeicingLogFilterData[K]
    ) => {
        let updatedFormData;
        setFormData(previous => {
            updatedFormData = {
                ...previous,
                [field]: value
            }
            return updatedFormData;
        });
    };

    return <div className="deice-summary-dialog">
        <div className="deice-summary-dialog-content">
            <div className="deice-summary-dialog-title">
                Ekologie (Excel)
            </div>
            {/* <DateTimeField
                label="Rok"
                value={formData?.dateFrom ?? null}
                onChange={value => updateField("dateFrom", value)}
                onSetCurrentTime={function (): void {
                    throw new Error("Function not implemented.");
                }}
            /> */}
            <YearInput
                value={formData?.year}
                label="Rok: "
                onChange={value => {
                    if (value !== null) {
                        updateField("year", value);
                    }
                }}
            />
            <div className="deice-summary-dialog-buttons">
                <button
                    type="button"
                    className="deice-summary-dialog-close"
                    onClick={onCloseDialog}
                >
                    Zrušit
                </button>
                <button
                    type="button"
                    className="deice-summary-dialog-confirm"
                    onClick={() => onConfirmDialog?.(formData)}
                >
                    Export
                </button>
            </div>
        </div>
    </div>
};

interface NumberFieldProps {
    label: string;
    value: number | null;
    min?: number;
    max?: number;
    onChange: (value: number | null) => void;
    readOnly?: boolean;
}

const NumberField: React.FC<NumberFieldProps> = ({
    label,
    value,
    min,
    max,
    onChange,
    readOnly = false
}) => (
    <label>
        {label}
        <input
            type="number"
            value={value ?? undefined}
            min={min}
            max={max}
            step={1}
            onChange={event =>
                onChange(
                    event.target.value === ""
                        ? null
                        : Number(event.target.value)
                )
            }
            readOnly={readOnly}
        />
    </label>
);

interface Option {
    value: string;
    label: string;
}

interface SelectFieldProps {
    label: string;
    value: string | number | null | undefined;
    options: Option[];
    onChange: (value: string) => void;
    disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
    label,
    value,
    options,
    onChange,
    disabled = false
}) => (
    <label>
        {label}
        <select
            value={value ?? undefined}
            onChange={event => onChange(event.target.value)}
            disabled={disabled}
        >
            <option value="">Vyberte hodnotu</option>

            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </label>
);

type YearInputProps = {
    label?: string;
    value?: number | null;
    disabled?: boolean;
    onChange: (year: number | null) => void;
};

export const YearInput = ({
    label,
    value,
    disabled,
    onChange,
}: YearInputProps) => {
    return (
        <div className="date-time-field">
            <label className="date-time-field__label">
                <span className="date-time-field__label-text">
                    <label>{label}</label>
                </span>

                <input
                    className="date-time-field__input"
                    type="number"
                    // min={1900}
                    // max={2100}
                    step={1}
                    value={value ?? ""}
                    disabled={disabled}
                    onChange={event =>
                        onChange(
                            event.target.value
                                ? Number(event.target.value)
                                : null
                        )
                    }
                />
            </label>

            {/* <button
                className="date-time-field__button"
                type="button"
                disabled={disabled}
                onClick={onSetCurrentTime}
            >
                Nastavit aktuální čas
            </button> */}
        </div>
    );
};

interface DateTimeFieldProps {
    label: string;
    value: string | null;
    onChange: (value: string | null) => void;
    onSetCurrentTime: () => void;
    disabled?: boolean;
}

const DateTimeField: React.FC<DateTimeFieldProps> = ({
    label,
    value,
    onChange,
    onSetCurrentTime,
    disabled = false,
}) => {
    return (
        <div className="date-time-field">
            <label className="date-time-field__label">
                <span className="date-time-field__label-text">
                    <label>{label}</label>
                </span>

                <input
                    className="date-time-field__input"
                    type="date"
                    value={value ?? ""}
                    disabled={disabled}
                    onChange={event =>
                        onChange(event.target.value || null)
                    }
                />
            </label>

            {/* <button
                className="date-time-field__button"
                type="button"
                disabled={disabled}
                onClick={onSetCurrentTime}
            >
                Nastavit aktuální čas
            </button> */}
        </div>
    );
};

export default DeicingLogFilterDialogWindow;